import { useEffect, useState, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { Link } from "react-router-dom";
import { setSelectProduct } from "../../../../../app/slices/productDiscriptionSlice/ProductDescriptionSlice";
import CustomDialog from "../../../../components/custom/dialog";
import { QuickAddModal } from "../../productListPage/components/quickAdd/quickAdd";
import { FilterProducts } from "../../productListPage/components/filterProduct";
import { getSpecialProductListAsync } from "../../../../../app/slices/specialProductSlice/specialProductSlice";
import {
  addToWisshListAsync,
  removeFromWishListAsync,
} from "../../../../../app/slices/wishlistSlice/wishlistSlice";
import { CircularProgress, useMediaQuery } from "@mui/material";
import { MobileAppRecommendationPrompt } from "../../locationSearchbar/mobileAppRecommendation";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getDecryptedToken } from "../../../../../app/auth/authHandler";
import { getProductImageUrl } from "../../../../../app/slices/common/imageConstants";

export const SpecialProducts = () => {
  const [modalType, setModalType] = useState("");

  const dispatch = useAppDispatch();
  const [filteredProducts, setFilteredProducts] = useState<any>([]);
  const hasFetched = useRef(false);
  const isMobileScreen = useMediaQuery("(max-width:765px)");
  const productsList = useAppSelector(
    (state) => state.SpecialProductState.specialProductsList
  );
  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };

  useEffect(() => {
    const accessToken = getDecryptedToken();
    const aId = localStorage.getItem("aId") ;
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (!productsList?.data || (productsList.data.length === 0 && (aId || accessToken))) {
      let payload: any = { anonymous_id: aId ? aId : null };
      dispatch(getSpecialProductListAsync(payload));
    }
  }, [dispatch, productsList?.data]);

  const isLargeScreen = useMediaQuery("(min-width:560px)");
  useEffect(() => {
  const handleBeforeUnload = () => {
    sessionStorage.removeItem("mobileRecommendationShown");
  };

  window.addEventListener("beforeunload", handleBeforeUnload);

  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
}, []);
 useEffect(() => {
  if (!isLargeScreen) {
    const hasShown = sessionStorage.getItem("mobileRecommendationShown");

    if (!hasShown) {
      onOpenModal("mobileRecommendation");
      sessionStorage.setItem("mobileRecommendationShown", "true");
    }
  }
}, [isLargeScreen]);
  const selectProduct = (id: any) => {
    dispatch(setSelectProduct(id));
    localStorage.setItem("product_id", id);
  };
  useEffect(() => {
    if (productsList.data) {
      setFilteredProducts(productsList?.data);
    }
  }, [productsList]);

  const handleFilterChange = (filters: {
    priceRange: number[];
    vegNonveg: string[];
  }) => {
    const { priceRange, vegNonveg } = filters;

    const filtered = productsList?.data
      .map((subcategory: any) => {
        const filteredProducts = subcategory.products.filter((product: any) => {
          const price = parseFloat(product.price);
          const isInPriceRange =
            price >= priceRange[0] && price <= priceRange[1];

          const isTypeMatch =
            vegNonveg.length > 0
              ? vegNonveg.includes(product.product_type)
              : true;

          return isInPriceRange && isTypeMatch;
        });

        return {
          ...subcategory,
          products: filteredProducts,
        };
      })
      .filter((subcategory: any) => subcategory.products.length > 0); // Remove empty subcategories
    setFilteredProducts(filtered);
  };
  const handleSort = (sortType: string) => {
    const sortedData = productsList?.data?.map((subcategory: any) => {
      const sortedProducts = [...subcategory.products];

      switch (sortType) {
        case "alphabeticalAsc":
          sortedProducts.sort((a, b) =>
            a.product_name.localeCompare(b.product_name)
          );
          break;

        case "alphabeticalDesc":
          sortedProducts.sort((a, b) =>
            b.product_name.localeCompare(a.product_name)
          );
          break;

        case "priceAsc":
          sortedProducts.sort(
            (a, b) => parseFloat(a.price) - parseFloat(b.price)
          );
          break;

        case "priceDesc":
          sortedProducts.sort(
            (a, b) => parseFloat(b.price) - parseFloat(a.price)
          );
          break;

        default:
          break;
      }

      return {
        ...subcategory,
        products: sortedProducts,
      };
    });

    setFilteredProducts(sortedData);
  };
  const percentageDisplay = (offer: any) => {
    if (!offer) {
      return null;
    }
    const percentage = parseFloat(offer.replace("%", ""));

    const formattedPercentage =
      percentage % 1 === 0
        ? `${Math.round(percentage)}%`
        : `${percentage.toFixed(2)}%`;

    return formattedPercentage;
  };
  const handleAddToWishList = (productId: any) => {
    const accessToken = getDecryptedToken();
    if (accessToken) {
      const updatedProducts = filteredProducts.map((item: any) => {
        return {
          ...item,
          products: item.products.map((product: any) => {
            if (product.product_id === productId) {
              return {
                ...product,
                wishlist: true,
              };
            }
            return product;
          }),
        };
      });
      setFilteredProducts(updatedProducts);
      addToWishList(productId);
    } else {
      dispatch(
        showSnackbar({
          message: "Please login to create wishlist",
          severity: "error",
          autoHide: 2000,
        })
      );
    }
  };

  const handleRemoveFromWishList = (productId: any) => {
    const updatedProducts = filteredProducts.map((item: any) => {
      return {
        ...item,
        products: item.products.map((product: any) => {
          if (product.product_id === productId) {
            return {
              ...product,
              wishlist: false,
            };
          }
          return product;
        }),
      };
    });

    setFilteredProducts(updatedProducts);
    removeFromWishList(productId);
  };
  const addToWishList = (id: any) => {
    dispatch(addToWisshListAsync(id));
  };
  const removeFromWishList = (id: any) => {
    dispatch(removeFromWishListAsync(id));
  };
  return (
    <>
      {productsList?.loader ? (
        <div id="wrapper">
          <div className="tf-shop-control grid-2 align-items-center justify-content-between">
            <div className="container" style={{ minHeight: "50vh" }}>
              <CircularProgress
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div id="wrapper">
          <section className="flat-spacing-1">
            <div className="container">
              <section className="flat-spacing-1 pt_0 flat-seller">
                {filteredProducts?.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      {item?.products?.length > 0 && (
                        <>
                          <div
                            className="flat-title"
                            style={{ paddingTop: index === 0 ? "0px" : "70px" }}
                          >
                            <span
                              className="title wow fadeInUp"
                              data-wow-delay="0s"
                            >
                              {item?.special_name}{" "}
                            </span>
                          </div>

                          <div data-wow-delay="0s" data-grid="grid-5">
                            {item?.products
                              ?.slice(0, 10)
                              .map((product: any, index: number) => {
                                return (
                                  <div
                                    key={index}
                                    className="card-product fl-item"
                                  >
                                    <div className="card-product-wrapper">
                                      <Link
                                        to={`/products/${product.product_id}`}
                                        onClick={() => {
                                          selectProduct(product?.product_id);
                                          localStorage.removeItem(
                                            "Category_code"
                                          );
                                        }}
                                      >
                                        <span className="product-img">
                                          <img
                                            className="lazyload img-product"
                                            data-src={getProductImageUrl(product?.product_img)}
                                            src={getProductImageUrl(product?.product_img)}
                                            alt="image-product"
                                          />
                                          <img
                                            className="lazyload img-hover"
                                            data-src={getProductImageUrl(product?.product_img)}
                                            src={getProductImageUrl(product?.product_img)}
                                            alt="image-product"
                                          />
                                        </span>
                                      </Link>
                                        {!isMobileScreen && (<div className="list-product-btn">
                                       <a
                                          onClick={() => {
                                            onOpenModal("quickAdd");
                                            selectProduct(product?.product_id);
                                          }}
                                          className="box-icon bg_white quick-add tf-btn-loading"
                                        >
                                          <span className="icon icon-bag"></span>
                                          <span className="tooltip">
                                            Quick Add
                                          </span>
                                        </a>
                                        <span
                                          className="box-icon bg_white wishlist btn-icon-action"
                                          onClick={() => {
                                            if (product?.wishlist !== true) {
                                              handleAddToWishList(
                                                product?.product_id
                                              );
                                            } else {
                                              handleRemoveFromWishList(
                                                product?.product_id
                                              );
                                            }
                                          }}
                                        >
                                          {product?.wishlist !== true ? (
                                            <span className="icon icon-heart"></span>
                                          ) : (
                                            <span className="icon icon-delete"></span>
                                          )}
                                          <span className="tooltip">
                                            {product?.wishlist !== true
                                              ? "Add to Wishlist"
                                              : "Remove from Wishlist"}
                                          </span>
                                        </span>
                                      </div>)}
                                      {/* Wishlist - Top Left */}
                                      {isMobileScreen && (<div className="wishlist-top">
                                      <span
                                        className="box-icon bg_white wishlist btn-icon-action"
                                        onClick={() => {
                                          if (product?.wishlist !== true) {
                                            handleAddToWishList(product?.product_id);
                                          } else {
                                            handleRemoveFromWishList(product?.product_id);
                                          }
                                        }}
                                      >
                                        {product?.wishlist !== true ? (
                                          <span className="icon icon-heart"></span>
                                        ) : (
                                          <span className="icon icon-delete"></span>
                                        )}
                                      </span>
                                    </div>)}

                                    {/* Offer Badge - Top Right */}

                                      <div className="on-sale-wrap text-end">
                                        {product?.offer &&
                                          product.offer !== "0%" && (
                                            <div className="on-sale-item">
                                              OFF{" "}
                                              {percentageDisplay(
                                                product?.offer
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-end">
                                      <div className="card-product-info">
                                        <Link
                                          to={`/products/${product.product_id}`} // Link to product description
                                          className="title link"
                                        >
                                          <span
                                            onClick={() =>
                                              selectProduct(product?.product_id)
                                            }
                                          >
                                            {product?.product_name}
                                          </span>
                                        </Link>
                                      </div>
                                      <div className="variant-picker-item">
                                        <div className="variant-picker-values">
                                          <input
                                            id="values-veg"
                                            type="radio"
                                            name="color1"
                                            checked
                                            // onChange={(e) => justclick(e)}
                                            readOnly
                                          />
                                          <label
                                            className={`hover-tooltip  ${
                                              product?.product_type === "Veg"
                                                ? "veg"
                                                : "nonveg"
                                            }`}
                                            htmlFor="values-veg"
                                            data-value="Veg"
                                          >
                                            <span
                                              className={`btn-checkbox    ${
                                                product?.product_type === "Veg"
                                                  ? "bg-color-veg bg-veg"
                                                  : "bg-color-nonveg "
                                              }`}
                                            ></span>
                                            <span className="tooltip">
                                              {product?.product_type}
                                            </span>
                                          </label>{" "}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tf-product-info-price mt-1">
                                      <div className="price fs-14 fw-6">
                                        ₹{product?.offerprice_with_tax}
                                      </div>
                                      <div className="compare-at-price fs-14">
                                        {product?.offer &&
                                          product.offer !== "0%" && (
                                            <span>₹{product?.price_with_tax}</span>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                          {item?.products?.length > 10 && (
                            <div className="tf-pagination-wrap view-more-button text-center">
                              <button className="tf-btn-loading tf-loading-default style-2 btn-loadmore">
                                <span className="text">Load more</span>
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
                {productsList?.data?.length === 0 && (
                  <div
                    style={{
                      fontSize: "18px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span className="title wow fadeInUp" data-wow-delay="0s">
                      No data found
                    </span>
                  </div>
                )}
              </section>
            </div>
          </section>
        </div>
      )}
      <CustomDialog
        component={
          <FilterProducts
            onFilterChange={handleFilterChange}
            filterInputs={[]}
          />
        }
        title="Filter"
        openDialog={modalType === "filter"}
        handleCloseDialog={onCloseModal}
        modalPlace="left"
      />
      {modalType === "quickAdd" && (
        <CustomDialog
          component={<QuickAddModal modalType={modalType} />}
          title="Quick Add"
          openDialog={modalType === "quickAdd"}
          handleCloseDialog={onCloseModal}
          modalPlace="center"
        />
      )}
      <CustomDialog
        component={<MobileAppRecommendationPrompt onClose={onCloseModal} />}
        title=""
        openDialog={modalType === "mobileRecommendation"}
        handleCloseDialog={onCloseModal}
        modalPlace="center"
      />
    </>
  );
};
